import { gql } from "@apollo/client"

export const UpdatePassword = gql`
mutation UpdatePassword($updatePasswordId: ID!, $content: contentPassword!) {
  updatePassword(id: $updatePasswordId, content: $content) {
    status
  }
}
`